import React from 'react';
import { Section } from '../components/Section';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { motion } from 'framer-motion';
const integrations = [{
  name: 'Amazon',
  category: 'Marketplace',
  logo: 'A'
}, {
  name: 'Newegg',
  category: 'Marketplace',
  logo: 'Ne'
}, {
  name: 'Shopify',
  category: 'E-commerce',
  logo: 'Sh'
}, {
  name: 'B&H Photo',
  category: 'Marketplace',
  logo: 'BH'
}, {
  name: 'Best Buy',
  category: 'Marketplace',
  logo: 'BB'
}, {
  name: 'Walmart',
  category: 'Marketplace',
  logo: 'W'
}, {
  name: 'Target',
  category: 'Marketplace',
  logo: 'T'
}, {
  name: 'Home Depot',
  category: 'Marketplace',
  logo: 'HD'
}, {
  name: "Lowe's",
  category: 'Marketplace',
  logo: 'L'
}, {
  name: 'Staples',
  category: 'Office',
  logo: 'S'
}, {
  name: 'Office Depot',
  category: 'Office',
  logo: 'OD'
}, {
  name: 'CDW',
  category: 'B2B',
  logo: 'CD'
}, {
  name: 'Grainger',
  category: 'Industrial',
  logo: 'G'
}, {
  name: 'Uline',
  category: 'Industrial',
  logo: 'U'
}, {
  name: 'DigiKey',
  category: 'Electronics',
  logo: 'D'
}, {
  name: 'Mouser',
  category: 'Electronics',
  logo: 'M'
}, {
  name: 'McMaster-Carr',
  category: 'Industrial',
  logo: 'MC'
}, {
  name: 'Alibaba',
  category: 'B2B',
  logo: 'Al'
}, {
  name: 'AliExpress',
  category: 'Marketplace',
  logo: 'AE'
}, {
  name: 'eBay',
  category: 'Marketplace',
  logo: 'E'
}];
export function Integrations() {
  return <div className="pt-20" data-id="element-321">
      <Section className="bg-gradient-to-br from-[#EEF2FF] to-white" data-id="element-322">
        <div className="container mx-auto px-4 text-center" data-id="element-323">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-324">
            Works on <br data-id="element-325" />
            <span className="text-[#6366F1]" data-id="element-326">any website</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-327">
            Capture cart information from any e-commerce platform or online
            store with a shopping cart.
          </p>
          <div className="flex justify-center gap-2 mb-12" data-id="element-328">
            {['All', 'Marketplace', 'B2B', 'Electronics'].map(filter => <button key={filter} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${filter === 'All' ? 'bg-[#6366F1] text-white' : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'}`} data-id="element-329">
                {filter}
              </button>)}
          </div>
        </div>
      </Section>

      <Section className="bg-white" data-id="element-330">
        <div className="container mx-auto px-4" data-id="element-331">
          <div className="text-center mb-12" data-id="element-332">
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-333">
              Popular Platforms
            </h2>
            <p className="text-gray-600" data-id="element-334">
              Here are some of the most commonly used sites
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6" data-id="element-335">
            {integrations.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: i * 0.05
          }} data-id="element-336">
                <Card className="p-6 flex flex-col items-center justify-center text-center h-40 hover:border-[#6366F1] transition-colors cursor-pointer group" data-id="element-337">
                  <div className="w-12 h-12 rounded-lg bg-gray-100 flex items-center justify-center text-xl font-bold text-gray-500 mb-4 group-hover:bg-[#6366F1] group-hover:text-white transition-colors" data-id="element-338">
                    {item.logo}
                  </div>
                  <h3 className="font-semibold text-gray-900" data-id="element-339">{item.name}</h3>
                  <p className="text-xs text-gray-500" data-id="element-340">{item.category}</p>
                </Card>
              </motion.div>)}
          </div>
        </div>
      </Section>

      <Section className="bg-[#6366F1] text-white" data-id="element-341">
        <div className="container mx-auto px-4 text-center" data-id="element-342">
          <h2 className="text-3xl font-bold mb-6" data-id="element-343">
            Need help with a specific site?
          </h2>
          <p className="text-lg text-white/80 mb-8" data-id="element-344">
            Our extension works on any website with a shopping cart. Contact us
            if you need assistance.
          </p>
          <Button variant="secondary" onClick={() => window.open('https://calendly.com/alex-thruline/cart-tracker', '_blank')} data-id="element-345">
            Contact Us
          </Button>
        </div>
      </Section>
    </div>;
}